import React from 'react';
import FormCrud from '../../components/FormCrud';

const TobaccoTypeForm = () => {
    const fields = [
        {
            label: "Name",
            name: "name",
            type: "input"
        }
    ]

    return (
        <FormCrud formName={"tobaccoType"} title={"Tobacco Type"} fields={fields}/>
    );
}

export default TobaccoTypeForm;
